import { FieldModel, ProgramBenchmarkName, ProgramTask, TaskDataTraitStatus } from '@cibo/core'
import { WaterPumpIrrigationCellDisplay } from '@cibo/landmanager'
import { TraitCellContainer } from './TraitCellContainer'

interface WaterPumpIrrigationCellProps {
  value: any
  task: ProgramTask<{ benchmarkName: ProgramBenchmarkName; traits: TaskDataTraitStatus[] }>
  year: number
  selectedField?: FieldModel
  onSaveSuccess?: () => void
}

export const WaterPumpIrrigationCell = ({
  value,
  task,
  selectedField,
  year,
  onSaveSuccess,
}: WaterPumpIrrigationCellProps) => (
  <TraitCellContainer
    value={value}
    task={task}
    selectedField={selectedField}
    year={year}
    traitId="waterPumpIrrigation"
    onSaveSuccess={onSaveSuccess}
  >
    <WaterPumpIrrigationCellDisplay value={value} />
  </TraitCellContainer>
)
